import Api from 'src/services/Api';
import { WORKSPACES_URL } from 'src/config/urls';
import { ScimTokenJSON } from '../models/ScimToken';

type GenerateScimTokenResponseJSON = {
	token: string;
}

export default class ScimSystem {
	private api: Api;

	constructor( { api }: { api: Api } ) {
		this.api = api;
	}

	async fetchScimToken( { workspaceID }: { workspaceID: number } ): Promise<ScimTokenJSON> {
		const url = `${WORKSPACES_URL}/${workspaceID}/scim_token`;
		const response = await ( this.api.get( url ) as Promise<{ response: ScimTokenJSON }> );
		return response.response;
	}

	async generateScimToken( { workspaceID }: { workspaceID: number } ): Promise<string> {
		const url = `${WORKSPACES_URL}/${workspaceID}/scim_token`;
		const response = await ( this.api.post( url ) as Promise<{ response: GenerateScimTokenResponseJSON }> );
		return response.response.token;
	}
}
